import { createContext } from 'react';

import { StatusHistory } from '@totem/components/ticketing/optimizeTypes';
import {
  Activity,
  ActivityConfiguration,
  OptimizeDeferralRequest,
  TicketQueryResult,
} from '@totem/components/ticketing/ticketing';

interface Context {
  ticket: TicketQueryResult;
  activityConfiguration: ActivityConfiguration[];
  loading: boolean;
  action: string;
  actionExtras: string;
  onAction: (newAction: string, extras: string) => void;
  onUpdateTicket: (ticket: TicketQueryResult) => void;
  onCreateActivity: (activity: Activity) => void;
  onOptimizeDeferral?: (payload: OptimizeDeferralRequest) => void;
  onOptimizeStatusChange?: (payload: StatusHistory) => void;
}

export default createContext<Context>({
  ticket: null,
  activityConfiguration: [],
  loading: false,
  action: '',
  actionExtras: '',
  onAction: () => {},
  onUpdateTicket: () => {},
  onCreateActivity: () => {},
  onOptimizeDeferral: () => {},
  onOptimizeStatusChange: () => {},
});
